import { SvgSetting } from '@/shared/lib/@deprecated/iport-icons/iconsB/guarantee/SvgSetting'
import { SvgStars } from '@/shared/lib/@deprecated/iport-icons/iconsB/guarantee/SvgStars'
import { SvgTool } from '@/shared/lib/@deprecated/iport-icons/iconsB/guarantee/SvgTool'

export const guaranteeFaq = [
	{
		question: `Как работает гарантия?`,
		answer: `При покупке техники Apple в iPort вы получаете 2 года гарантийного обслуживания. Гарантия на iPhone Duo и наушники Apple составляет 12 месяцев. На определённые категории товаров гарантия распространяется только при условии их приобретения в iPort. Подробности у продавцов-консультантов и в сервисных центрах.`
	},
	{
		question: `Нужно ли будет что-то доплатить?`,
		answer: `Нет, гарантийное обслуживание проводится бесплатно.`
	},
	{
		question: `Как сдать устройство на гарантийное обслуживание?`,
		answer: `Принесите устройство в любой фирменный магазин или сервисный центр iPort.`
	},
	{
		question: `Может ли за меня сдать устройство в ремонт другой человек?`,
		answer: `Да, может. При оформлении ему нужно будет указать информацию о владельце устройства — ФИО, телефон и e-mail.`
	},
	{
		question: `Как проверить, что устранили неисправность?`,
		answer: `После гарантийного обслуживания вы получаете заключение от нашего сервисного центра и можете на месте проверить работоспособность своего устройства.`
	},
	{
		question: `Есть ли гарантия на ремонт?`,
		answer: `Да, мы даем до 90 дней гарантии на выполненные работы.`
	}
]

export const guaranteeItems = [
	{
		title: `Будьте уверены в вашем выборе`,
		subtitle: `В iPort вы можете приобрести оригинальную продукцию Apple и получить гарантийное и постгарантийное обслуживание.`,
		textItems: [
			{
				image: SvgStars,
				title: `Квалификация`,
				subtitle: `Наши инженеры прошли специальное обучение.`
			},
			{
				image: SvgSetting,
				title: `Качественные запчасти`,
				subtitle: `Мы используем только качественные запчасти.`
			},
			{
				image: SvgTool,
				title: `Качество ремонта`,
				subtitle: `Гарантия на все проведённые работы.`
			}
		]
	}
]

export const guaranteeNotation = {
	subtitle:
		'По вопросам гарантийного обслуживания купленных устройств вы можете обратиться  в любой магазин iPort либо сервисные центры.',
	link: {
		text: 'Адреса сервисных центров',
		href: '/shops/?show=services'
	}
}
